import {
  DeadlineChipStatus,
  StatusToStyle,
} from 'app/modules/deadlines/models';
import { IconClockExclamation } from '@u21/tabler-icons';

export const CHIP_STATUS_TO_STYLE: StatusToStyle = {
  [DeadlineChipStatus.PAST_DEADLINE]: {
    color: 'error',
    icon: <IconClockExclamation />,
    variant: 'filled',
  },
  [DeadlineChipStatus.WARN_BEFORE_DEADLINE]: {
    color: 'warning',
    icon: <IconClockExclamation />,
    variant: 'filled',
  },
  [DeadlineChipStatus.NORMAL_DEADLINE]: {
    color: 'primary',
    variant: 'ghost',
  },
  [DeadlineChipStatus.NO_DEADLINE]: { color: 'default', variant: 'filled' },
};
